import React, { useEffect } from 'react';
import { TopBar, WhatsAppButton, PurchaseNotifications } from '../components/Layout';
import { trackFb } from '../lib/fbpixel';
import { Hero, Tension, WhatThisIs, MainCollection } from '../components/Sections';
import { Volumes, Bonuses, Benefits, PostPurchase } from '../components/ContentSections';
import { Pricing, Guarantee, FAQ, FinalCTA } from '../components/ConversionSections';
export function LandingPage() {
  useEffect(() => {
    // Fire ViewContent when the sales page loads
    trackFb('ViewContent', {
      content_name: 'Colección NOS MIENTEN',
      content_type: 'product',
      currency: 'ARS',
      value: 27990
    });
  }, []);
  return <div className="min-h-screen bg-brand-dark flex flex-col font-sans selection:bg-brand-gold selection:text-brand-dark" data-id="element-194">
      <TopBar data-id="element-195" />

      <main className="flex-1" data-id="element-196">
        <Hero data-id="element-197" />
        <Tension data-id="element-198" />
        <WhatThisIs data-id="element-199" />
        <MainCollection data-id="element-200" />
        <Volumes data-id="element-201" />
        <Bonuses data-id="element-202" />
        <Benefits data-id="element-203" />
        <PostPurchase data-id="element-204" />
        <Pricing data-id="element-205" />
        <Guarantee data-id="element-206" />
        <FAQ data-id="element-207" />
        <FinalCTA data-id="element-208" />
      </main>

      <footer className="bg-brand-anthracite py-8 border-t border-brand-card text-center px-5" data-id="element-209">
        <p className="text-brand-muted text-xs" data-id="element-210">
          &copy; {new Date().getFullYear()} Colección Nos Mienten. Todos los
          derechos reservados.
        </p>
      </footer>

      <WhatsAppButton data-id="element-211" />
      <PurchaseNotifications data-id="element-212" />
    </div>;
}